// 获取用户授信列表
import { AxiosServer } from '../../../utils';

// 通过 social_credit_code 和 guarantee_type 查找单个
export default function findClientCreditList(social_credit_code, guarantee_type) {
    let axios = AxiosServer();
    return axios.post("clientCredit/findAll", {
        attributes: [
            "sap_no",
            "apply_no",
            "audit_opinion",
            "audit_result",
            "audit_time",
            "credit_amount",
            "social_credit_code",
            "credit_type"
        ],
        social_credit_code,
        guarantee_type,  // 添加 guarantee_type 参数
    }).then(result => {
        if (result.data.status === true) {
            return result.data;
        } else {
            return Promise.reject("false");
        }
    });
}
